<template>
  <woot-modal :show.sync="show" :on-close="onClose" size="medium">
    <div class="column content-box">
      <woot-modal-header
        :header-title="$t('CAMPAIGN_FLOW.LIST_CONTACTS.CREATE.TITLE')"
        :header-content="$t('CAMPAIGN_FLOW.LIST_CONTACTS.CREATE.DESC')"
      />
      <form class="row" @submit.prevent="handleSubmit">
        <div class="medium-12 columns">
          <label :class="{ error: $v.name.$error }">
            {{ $t('CAMPAIGN_FLOW.LIST_CONTACTS.CREATE.FORM.NAME.LABEL') }}
            <input
              v-model.trim="name"
              type="text"
              :placeholder="$t('CAMPAIGN_FLOW.LIST_CONTACTS.CREATE.FORM.NAME.PLACEHOLDER')"
              @input="$v.name.$touch()"
            />
          </label>
        </div>

        <div class="medium-12 columns">
          <label>
            {{ $t('CAMPAIGN_FLOW.LIST_CONTACTS.CREATE.FORM.UPLOAD.LABEL') }}
            <input
              type="file"
              @change="handleFileUpload"
              accept="text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </label>
        </div>
        <div class="medium-12 columns">
          <woot-button @click="toggleContactsModal" type="button">
            {{
              contactsIdsExisting.length
                ? `${contactsIdsExisting.length} ${$t('CAMPAIGN_FLOW.LIST_CONTACTS.CREATE.FORM.CONTACTS.SELECTED_CONTACTS')}`
                : `${$t('CAMPAIGN_FLOW.LIST_CONTACTS.CREATE.FORM.CONTACTS.SELECT_CONTACTS')}`
            }}
          </woot-button>
        </div>

        <div class="modal-footer">
          <div class="medium-12 columns">
            <woot-submit-button
              :disabled="$v.$invalid || showLoading"
              :button-text="$t('CRM_MGMT.FORM.CREATE')"
              :loading="showLoading"
              class="bg-primary"
            />
            <button class="button clear" @click.prevent="onClose">
              {{ $t('CRM_MGMT.FORM.CANCEL') }}
            </button>
          </div>
        </div>
      </form>
    </div>

    <woot-modal
      :show.sync="contactsModal"
      :on-close="toggleContactsModal"
      size="modal-xl"
    >
      <div class="column content-box">
        <div class="row">
          <contacts-view
            is-picker
            :contacts-ids="contactsIds"
            :contacts-ids-list="contactsIdsExisting"
            @toggle-contacts-view="toggleContactsModal"
            @handle-contacts-selected="handleExistingContacts"
          />
        </div>
      </div>
    </woot-modal>

      <hire-plan-modal
        :show-modal="showPlanHireModal"
        :integration="integration"
        @hide-modal-hire-plan="closeModalHirePlan"
    />
  </woot-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import xlsx from 'xlsx';
import ContactsView from '../../contacts/components/ContactsView.vue';
import { mapGetters } from 'vuex';
import HirePlanModal from '../../settings/integrationapps/HirePlanModal.vue';

export default {
  components: { ContactsView, HirePlanModal},
  props: {
    show: Boolean,
    onClose: Function,
  },
  data() {
    return {
      name: '',
      file: null,
      showLoading: false,
      contacts: [],
      contactsModal: false,
      contactsIdsExisting: [],
      contactsIds: [],
      showPlanHireModal: false
    };
  },
  validations: {
    name: { required },
  },

  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
      currentAccountId: 'getCurrentAccountId',
    }),
    integration(){
      return { id: 'campaign_flow', name: this.$t('CAMPAIGN_FLOW.TITLE')}
    },
    account() {
      return this.getAccount(this.currentAccountId);
    },
  },

  mounted() {
    this.$store.dispatch('contacts/getContactViews', {
      page: 1,
    });
    this.getAllContactsList();
  },
  methods: {
    closeModalHirePlan() {
      this.showPlanHireModal = false;
    },
    handleExistingContacts(contactsIds) {
      this.contactsIdsExisting = contactsIds;
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.showLoading = true;
        const reader = new FileReader();
        reader.onload = e => {
          const data = new Uint8Array(e.target.result);
          const workbook = xlsx.read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const json = xlsx.utils.sheet_to_json(worksheet);
          this.contacts = json;
          this.showLoading = false;
        };
        reader.readAsArrayBuffer(file);
      }
    },
    toggleContactsModal() {
      this.contactsModal = !this.contactsModal;
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      if(!this.account.enable_campaign_flow) {
        this.showPlanHireModal = true;
        return;
      }

      this.showLoading = true;
      const payload = {
        name: this.name,
        contacts: this.contacts,
        contacts_ids: this.contactsIdsExisting,
      };
      try {
        this.$emit('submit', payload);
      } finally {
        this.showLoading = false;
      }
    },
    async getAllContactsList() {
      try {
        const { contact_ids } = await this.$store.dispatch(
          'campaignsContactList/getAllContacts'
        );
        this.contactsIds = contact_ids;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
.modal-footer .button {
  margin-left: 0 !important;
}
</style>
